module.exports = __webpack_public_path__ + "static/img/list3.0ff52af.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/wap/list3.png
// module id = mlYY
// module chunks = 0